var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg045GasMask = function Svg045GasMask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 181,
    r: 30
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 331,
    cy: 181,
    r: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 422c24.814 0 45-20.186 45-45s-20.186-45-45-45-45 20.186-45 45 20.186 45 45 45m-15-60h30v30h-30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 211h30.769c3.704 47.404 25.648 93.175 60.231 126.42V377H90v60h45.903c21.956 44.365 67.194 75 120.097 75s98.141-30.635 120.097-75H422v-60h-31v-39.565c34.581-33.257 56.525-79.04 60.231-126.435H482v-30h-30.76C443.531 80.484 358.457 0 256 0S68.469 80.484 60.76 181H30zm301-90c33.091 0 60 26.909 60 60s-26.909 60-60 60-60-26.909-60-60 26.909-60 60-60m0 256c0 41.353-33.647 75-75 75s-75-33.647-75-75 33.647-75 75-75 75 33.647 75 75M181 121c33.091 0 60 26.909 60 60s-26.909 60-60 60-60-26.909-60-60 26.909-60 60-60M0 332h60v150H0zM452 332h60v150h-60z"
  })));
};
export default Svg045GasMask;